import { ValidationRuleSeverity, ValidationRuleViolation } from "@sp-crm/core";
import { InlineBanner } from "components/ui/inline-banner";
import React from "react";

export const partitionValidationViolations = (
    violations: ValidationRuleViolation[] | undefined,
): {
    blockingViolations: ValidationRuleViolation[];
    warningViolations: ValidationRuleViolation[];
} => {
    const allViolations = violations ?? [];
    return {
        blockingViolations: allViolations.filter(
            v => v.severity === ValidationRuleSeverity.Hard,
        ),
        warningViolations: allViolations.filter(
            v => v.severity === ValidationRuleSeverity.Warning,
        ),
    };
};

const ValidationMessages: React.FC<{ messages: string[] }> = ({ messages }) =>
    messages.length > 1 ? (
        <ul className="list-disc pl-4 text-sm">
            {messages.map((message, index) => (
                <li key={index}>{message}</li>
            ))}
        </ul>
    ) : (
        <>{messages[0]}</>
    );

export const ValidationViolationBanners: React.FC<{
    blockingViolations: ValidationRuleViolation[];
    warningViolations: ValidationRuleViolation[];
}> = ({ blockingViolations, warningViolations }) => (
    <>
        {blockingViolations.length > 0 ? (
            <InlineBanner type="error">
                <ValidationMessages
                    messages={blockingViolations.map(violation => violation.message)}
                />
            </InlineBanner>
        ) : null}
        {warningViolations.length > 0 ? (
            <InlineBanner type="warning">
                <ValidationMessages
                    messages={warningViolations.map(violation => violation.message)}
                />
            </InlineBanner>
        ) : null}
    </>
);
